webpackJsonp([144251824217401],{

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function Fade(e,t){function o(e){function t(){var t=p||u||i||a||l||s,o=void 0,r=void 0;if(t){var d=n?"2000px":"100%",f=_&&e;o=p?(f?"":"-")+d:u?(f?"-":"")+d:"0",r=a||l?(f?"":"-")+d:i||s?(f?"-":"")+d:"0"}return(0,_globals.animation)((e?"to":"from")+" {opacity: 0;"+(t?" transform: translate3d("+o+", "+r+", 0);":"")+"}\n         "+(e?"from":"to")+" {opacity: 1;transform: none;} ")}return{reverse:p,make:t}}var r=e.out,p=e.left,u=e.right,i=e.up,a=e.down,l=e.top,s=e.bottom,n=e.big,_=e.opposite,d=(0,_objectWithoutProperties3.default)(e,["out","left","right","up","down","top","bottom","big","opposite"]);return t?_react2.default.createElement(_Reveal2.default,(0,_extends3.default)({},d,{in:o(!1),out:o(!0)})):o(r)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(4),_extends3=_interopRequireDefault(_extends2),_objectWithoutProperties2=__webpack_require__(8),_objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2),_react=__webpack_require__(1),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(3),_Reveal=__webpack_require__(5),_Reveal2=_interopRequireDefault(_Reveal),_globals=__webpack_require__(6),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,big:_propTypes.bool,opposite:_propTypes.bool},defaultProps={};Fade.propTypes=propTypes,Fade.defaultProps=defaultProps,exports.default=Fade,module.exports=exports.default;

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function Flip(e,t){function n(e){function t(){var t=void 0;if(s||u||r||p||i||a){var n=e&&l,o=s||i||a?(a?n?"":"-":n?"-":"")+"1":"0",f=u||p||r?(r?n?"":"-":n?"-":"")+"1":"0";t=e?"from {\n              transform: perspective(400px);\n            }\n\n            30% {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, -15deg);\n              opacity: 1;\n            }\n\n            to {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, 90deg);\n              opacity: 0;\n            }":"from {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, 90deg);\n              animation-timing-function: ease-in;\n              opacity: 0;\n            }\n\n            40% {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, -20deg);\n              animation-timing-function: ease-in;\n            }\n\n            60% {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, 10deg);\n              opacity: 1;\n            }\n\n            80% {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, -5deg);\n            }\n\n            to {\n              transform: perspective(400px);\n            }"}else t="from {\n              transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n              animation-timing-function: ease-out;\n              opacity: "+(e?"1":"0")+";\n            }\n\n            40% {\n              transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n              animation-timing-function: ease-out;\n            }\n\n            50% {\n              transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n              animation-timing-function: ease-in;\n            }\n\n            to {\n              transform: perspective(400px);\n              animation-timing-function: ease-in;\n              opacity: "+(e?"0":"1")+";\n            }";return(0,_globals.animation)(t)}return{style:{backfaceVisibility:"visible"},make:t}}var o=e.out,r=e.left,p=e.right,i=e.top,a=e.bottom,s=e.x,u=e.y,l=e.opposite,f=(0,_objectWithoutProperties3.default)(e,["out","left","right","top","bottom","x","y","opposite"]);return t?_react2.default.createElement(_Reveal2.default,(0,_extends3.default)({},f,{in:n(!1),out:n(!0)})):n(o)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(4),_extends3=_interopRequireDefault(_extends2),_objectWithoutProperties2=__webpack_require__(8),_objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2),_react=__webpack_require__(1),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(3),_Reveal=__webpack_require__(5),_Reveal2=_interopRequireDefault(_Reveal),_globals=__webpack_require__(6),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,opposite:_propTypes.bool},defaultProps={};Flip.propTypes=propTypes,Flip.defaultProps=defaultProps,exports.default=Flip,module.exports=exports.default;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(4),_extends3=_interopRequireDefault(_extends2),_getPrototypeOf=__webpack_require__(57),_getPrototypeOf2=_interopRequireDefault(_getPrototypeOf),_classCallCheck2=__webpack_require__(9),_classCallCheck3=_interopRequireDefault(_classCallCheck2),_createClass2=__webpack_require__(18),_createClass3=_interopRequireDefault(_createClass2),_possibleConstructorReturn2=__webpack_require__(16),_possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2),_inherits2=__webpack_require__(15),_inherits3=_interopRequireDefault(_inherits2),_react=__webpack_require__(1),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(3),_globals=__webpack_require__(6),_Step=__webpack_require__(32),_Step2=_interopRequireDefault(_Step),_debounce=__webpack_require__(34),_debounce2=_interopRequireDefault(_debounce),propTypes={when:_propTypes.bool,spy:_propTypes.any,effect:_propTypes.string,collapse:(0,_propTypes.oneOfType)([_propTypes.bool,_propTypes.string]),duration:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool,tag:_propTypes.string,step:(0,_propTypes.oneOfType)([(0,_propTypes.instanceOf)(_Step2.default),_propTypes.string]),className:_propTypes.string,style:_propTypes.object,props:_propTypes.object,force:_propTypes.bool,bypass:_propTypes.bool,fraction:_propTypes.number,onReveal:_propTypes.func,children:_propTypes.node.isRequired,in:_propTypes.object,out:(0,_propTypes.oneOfType)([_propTypes.object,_propTypes.bool])},defaultProps={duration:1e3,delay:0,count:1,fraction:.2,tag:"div",when:!0},contextTypes={stepper:_propTypes.object},RevealBase=function(e){function t(e){(0,_classCallCheck3.default)(this,t);var s=(0,_possibleConstructorReturn3.default)(this,(t.__proto__||(0,_getPrototypeOf2.default)(t)).call(this,e));return s.state={legacyMode:!1,style:{height:e.collapse?0:void 0,visibility:e.collapse?e.when||!e.out?"visible":"hidden":void 0,opacity:!e.when&&e.out?0:void 0}},s.isListener=!1,s.isShown=!!s.props.bypass,s.revealHandler=(0,_debounce2.default)(s.reveal.bind(s,!1),66),s.resizeHandler=(0,_debounce2.default)(s.resize.bind(s),500),s.invisible=(0,_debounce2.default)(s.invisible,500),s.saveRef=function(e){return s.el=e},s}return(0,_inherits3.default)(t,e),(0,_createClass3.default)(t,[{key:"inViewport",value:function(){if(!this.el||window.document.hidden)return!1;var e=this.el.offsetHeight,s=window.pageYOffset-t.getTop(this.el),i=Math.min(e,window.innerHeight)*(_globals.globalHide?this.props.fraction:0);return s>i-window.innerHeight&&s<e-i}},{key:"hide",value:function(){this.props.out&&this.setState({style:{opacity:0}})}},{key:"resize",value:function(){this&&this.el&&this.props.when&&this.inViewport()&&(this.clean(),this.isShown=!!this.props.when,this.setState({style:{opacity:this.props.when||!this.props.out?1:0}}),this.props.onReveal&&this.props.when&&this.props.onReveal())}},{key:"invisible",value:function(){this&&!this.isShown&&this.setState({style:(0,_extends3.default)({},this.state.style,{visibility:"hidden"})})}},{key:"animationEnd",value:function(e,t){var s=this;if(!t){var i=this.finalEl||this.el,n=function t(){s&&i&&(i.removeEventListener("animationend",t),e.call(s))};i.addEventListener("animationend",n)}}},{key:"collapse",value:function(e,t){if(t.collapse&&t.out){var s=t.duration+(t.cascade?!0===t.cascade?1e3:t.cascade:0),i=s>>2,n=t.when?i:s-i,o=t.delay+(t.when?0:i);return(0,_extends3.default)({},e,{height:t.when?!0===t.collapse?this.dummyEl.offsetHeight:t.collapse:0,transition:"height "+n+"ms ease "+o+"ms"})}return e}},{key:"animate",value:function(e){if(this&&this.el){if(this.clean(),e.effect)this.setState({legacyMode:!0});else{var t=e[e.when||!e.out?"in":"out"],s=e.out||e.when?t.animation||t.make():void 0;if(this.isShown===!!e.when)return;this.isShown=!!e.when,this.setState({style:this.collapse((0,_extends3.default)({animationName:s,animationDuration:e.duration+"ms",animationDelay:e.delay+"ms",animationIterationCount:e.forever?"infinite":e.count,animationFillMode:"both",opacity:1},t.style),e)}),!e.when&&e.out&&this.animationEnd(this.invisible,e.forever)}e.onReveal&&e.when&&e.onReveal()}}},{key:"clean",value:function(){this.isListener&&(window.removeEventListener("scroll",this.revealHandler),window.removeEventListener("orientationchange",this.revealHandler),window.document.removeEventListener("visibilitychange",this.revealHandler),window.removeEventListener("resize",this.resizeHandler),this.isListener=!1)}},{key:"componentWillUnmount",value:function(){this.clean(),_globals.ssr&&(0,_globals.disableSsr)()}},{key:"listen",value:function(){this.isListener||(this.isListener=!0,window.addEventListener("scroll",this.revealHandler),window.addEventListener("orientationchange",this.revealHandler),window.document.addEventListener("visibilitychange",this.revealHandler),window.addEventListener("resize",this.resizeHandler))}},{key:"reveal",value:function(e){var t=this;if(this&&this.el)if(e||(e=this.props),this.inViewport()){if(this.start)return this.hide(),this.listen(),void this.start(this.step);e.when&&this.isShown&&"spy"in e?(this.isShown=!1,this.setState({style:{}}),window.setTimeout(function(){return t.animate.call(t,e)},200)):this.animate(e)}else this.listen()}},{key:"componentDidMount",value:function(){if(this.el&&!this.props.bypass){if(this.props.force)return this.animate(this.props);this.props.step instanceof _Step2.default?this.props.step.push(this):this.props.step&&this.context.stepper&&this.context.stepper.get(this.props.step).push(this),_globals.ssr&&(this.props.out||this.props.effect)&&t.getTop(this.el)<window.pageYOffset+window.innerHeight?(this.setState({style:{opacity:0,transition:"opacity 1000ms"}}),window.setTimeout(this.revealHandler,1e3)):this.props.when&&this.reveal(this.props)}}},{key:"cascade",value:function(e){var t=this,s=void 0;s="string"==typeof e?e.split("").map(function(e,t){return _react2.default.createElement("span",{key:t,style:{display:"inline-block",whiteSpace:"pre"}},e)}):_react2.default.Children.toArray(e);var i=s.length-1,n=this.props.duration+(!0===this.props.cascade?1e3:this.props.cascade),o=0;return s=s.map(function(e){return _react2.default.cloneElement(e,{style:(0,_extends3.default)({},e.props.style,t.state.style,{animationDuration:Math.round((0,_globals.cascade)(o++,0,i,t.props.duration,n))+"ms"}),ref:o===i?function(e){return t.finalEl=e}:void 0})})}},{key:"componentWillReceiveProps",value:function(e){e.when===this.props.when&&e.spy===this.props.spy||this.reveal(e)}},{key:"dummy",value:function(e){var t=this;if(!0!==this.props.collapse)return e;var s=[e,_react2.default.createElement(e.type,(0,_extends3.default)({},this.props.props||void 0,{className:this.props.className,children:this.props.children,key:2,ref:function(e){return t.dummyEl=e},style:(0,_extends3.default)({},this.props.style,{position:"absolute",left:"-9999em",top:"-9999em",height:"auto",display:"block",animationName:"none",animationDuration:"0s",transition:"none",opacity:0})}))];return _react2.default.createElement("span",null,s)}},{key:"render",value:function(){var e=this.props,t=e.tag,s=e.id,i=e.children,n=e.style,o=e.className,r=(this.state.legacyMode?this.props.effect:this.props.out||this.props.effect?_globals.namespace:"")+(o?" "+o:"")||void 0,a=void 0,p=!1;this.state.legacyMode||(a=(0,_extends3.default)({},n,this.state.style),this.props.cascade&&i&&this.state.style.animationName&&(p=this.cascade(i),a.animationName=void 0));var l=_react2.default.createElement(t,(0,_extends3.default)({},this.props.props||void 0,{id:s,className:r,style:this.state.legacyMode?n:a,key:this.props.collapse?1:void 0,ref:this.saveRef}),p||i);return this.props.collapse?this.dummy(l):l}}],[{key:"getTop",value:function(e){for(;void 0===e.offsetTop;)e=e.parentNode;for(var t=e.offsetTop;e.offsetParent;t+=e.offsetTop)e=e.offsetParent;return t}}]),t}(_react2.default.Component);RevealBase.propTypes=propTypes,RevealBase.defaultProps=defaultProps,RevealBase.contextTypes=contextTypes,exports.default=RevealBase,module.exports=exports.default;

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function Rotate(e,t){function o(e){function t(){var t="-200deg",o="center";return e&&n?((l||a)&&u&&(t="-45deg"),((l||a)&&p||(s||i)&&u)&&(t="45deg"),(s||i)&&p&&(t="-90deg"),(p||u)&&(o=(u?"left":"right")+" bottom")):((s||i)&&p&&(t="-45deg"),((s||i)&&u||(l||a)&&p)&&(t="45deg"),(l||a)&&u&&(t="-90deg"),(p||u)&&(o=(p?"left":"right")+" bottom")),(0,_globals.animation)("\n        "+(e?"to":"from")+" { opacity: 0; transform-origin: "+o+"; transform: rotate3d(0, 0, 1, "+t+");}\n        "+(e?"from":"to")+" { opacity: 1; transform-origin: "+o+"; transform: none;}\n      ")}return{make:t}}var r=e.out,p=e.left,u=e.right,i=e.top,a=e.bottom,l=e.up,s=e.down,n=e.opposite,_=(0,_objectWithoutProperties3.default)(e,["out","left","right","top","bottom","up","down","opposite"]);return t?_react2.default.createElement(_Reveal2.default,(0,_extends3.default)({},_,{in:o(!1),out:o(!0)})):o(r)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(4),_extends3=_interopRequireDefault(_extends2),_objectWithoutProperties2=__webpack_require__(8),_objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2),_react=__webpack_require__(1),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(3),_Reveal=__webpack_require__(5),_Reveal2=_interopRequireDefault(_Reveal),_globals=__webpack_require__(6),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,opposite:_propTypes.bool},defaultProps={};Rotate.propTypes=propTypes,Rotate.defaultProps=defaultProps,exports.default=Rotate,module.exports=exports.default;

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});var _classCallCheck2=__webpack_require__(9),_classCallCheck3=_interopRequireDefault(_classCallCheck2),_createClass2=__webpack_require__(18),_createClass3=_interopRequireDefault(_createClass2),Step=function(){function e(t){var s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1e3;(0,_classCallCheck3.default)(this,e),this.after=s,this.name=t,this.chain=[]}return(0,_createClass3.default)(e,[{key:"push",value:function(e){this.start&&(e.step=this.index,e.start=this.start),this.chain.push(e)}}]),e}();exports.default=Step,module.exports=exports.default;

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function Zoom(e,t){function o(e){function t(){var t=p||n,o=i||a||s||u,r=t||o,c=void 0,f=void 0,d=void 0,_=void 0,m=void 0;return r?e?(f=t?((l?n:p)?"":"-")+"42px":"0",d=o?((l?s||a:u||i)?"-":"")+"60px":"0",_=t?((l?p:n)?"":"-")+"2000px":"0",m=o?((l?u||i:s||a)?"":"-")+"2000px":"0",c="40% {\n              opacity: 1;\n              transform: scale3d(.475, .475, .475) translate3d("+f+", "+d+", 0);\n            }\n            to {\n              opacity: 0;\n              transform: scale(.1) translate3d("+_+", "+m+", 0);\n              transform-origin: "+(o?"center bottom":((l?n:p)?"left":"right")+" center")+";\n            }"):(f=t?(p?"-":"")+"1000px":"0",d=o?(u||i?"-":"")+"1000px":"0",_=t?(n?"-":"")+"10px":"0",m=o?(s||a?"-":"")+"60px":"0",c="from {\n              opacity: 0;\n              transform: scale3d(.1, .1, .1) translate3d("+f+", "+d+", 0);\n              animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n            }\n            60% {\n              opacity: 1;\n              transform: scale3d(.475, .475, .475) translate3d("+_+", "+m+", 0);\n              animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n            }"):c=(e?"to":"from")+" {opacity: 0; transform: scale3d(.1, .1, .1);} "+(e?"from":"to")+" { opacity: 1; transform: none;}",(0,_globals.animation)(c)}return{make:t}}var r=e.out,p=e.left,n=e.right,i=e.top,a=e.bottom,s=e.up,u=e.down,l=e.opposite,c=(0,_objectWithoutProperties3.default)(e,["out","left","right","top","bottom","up","down","opposite"]);return t?_react2.default.createElement(_Reveal2.default,(0,_extends3.default)({},c,{in:o(!1),out:o(!0)})):o(r)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(4),_extends3=_interopRequireDefault(_extends2),_objectWithoutProperties2=__webpack_require__(8),_objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2),_react=__webpack_require__(1),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(3),_Reveal=__webpack_require__(5),_Reveal2=_interopRequireDefault(_Reveal),_globals=__webpack_require__(6),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,opposite:_propTypes.bool},defaultProps={};Zoom.propTypes=propTypes,Zoom.defaultProps=defaultProps,exports.default=Zoom,module.exports=exports.default;

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

	"use strict";function debounce(e,t,u){var o;return function(){var r=this,n=arguments,l=function(){o=null,u||e.apply(r,n)},p=u&&!o;clearTimeout(o),o=setTimeout(l,t),p&&e.apply(r,n)}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=debounce,module.exports=exports.default;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	"use strict";function insertRule(e){try{return sheet.insertRule(e,sheet.cssRules.length)}catch(e){console.warn("react-reveal - animation failed")}}function cascade(e,n,t,i,o){var r=Math.log(i),s=Math.log(o),a=(s-r)/(t-n);return Math.exp(r+a*(e-n))}function animation(e){if(!sheet)return"";var n="@keyframes "+(name+counter)+"{"+e+"}",t=effectMap[e];return t?""+name+t:(sheet.insertRule(n,sheet.cssRules.length),effectMap[e]=counter,""+name+counter++)}function hideAll(){window.removeEventListener("scroll",hideAll,!0),insertRule("."+namespace+" { opacity: 0; }"),window.removeEventListener("orientationchange",hideAll,!0),window.document.removeEventListener("visibilitychange",hideAll),exports.globalHide=globalHide=!0}Object.defineProperty(exports,"__esModule",{value:!0}),exports.insertRule=insertRule,exports.cascade=cascade,exports.animation=animation;var namespace=exports.namespace="react-reveal",is16=exports.is16=!1,ssr=exports.ssr=!0,disableSsr=exports.disableSsr=function(){return exports.ssr=ssr=!1},globalHide=exports.globalHide=!1,counter=1,effectMap={},sheet=!1,name=namespace+"-"+Math.floor(1e15*Math.random())+"-";if("undefined"!=typeof window&&"nodejs"!==window.name&&window.document&&"undefined"!=typeof navigator){exports.ssr=ssr=window.document.querySelectorAll("div[data-reactroot]").length>0,ssr&&"performance"in window&&"timing"in window.performance&&"domContentLoadedEventEnd"in window.performance.timing&&window.performance.timing.domLoading&&Date.now()-window.performance.timing.domLoading<500&&(exports.ssr=ssr=!1);var element=document.createElement("style");document.head.appendChild(element),element.sheet&&element.sheet.cssRules&&element.sheet.insertRule&&(sheet=element.sheet,window.addEventListener("scroll",hideAll,!0),window.addEventListener("orientationchange",hideAll,!0),window.document.addEventListener("visibilitychange",hideAll))}

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});var _Reveal=__webpack_require__(5);Object.defineProperty(exports,"default",{enumerable:!0,get:function(){return _interopRequireDefault(_Reveal).default}});var _Fade=__webpack_require__(29);Object.defineProperty(exports,"Fade",{enumerable:!0,get:function(){return _interopRequireDefault(_Fade).default}});var _Flip=__webpack_require__(30);Object.defineProperty(exports,"Flip",{enumerable:!0,get:function(){return _interopRequireDefault(_Flip).default}});var _Rotate=__webpack_require__(31);Object.defineProperty(exports,"Rotate",{enumerable:!0,get:function(){return _interopRequireDefault(_Rotate).default}});var _Zoom=__webpack_require__(33);Object.defineProperty(exports,"Zoom",{enumerable:!0,get:function(){return _interopRequireDefault(_Zoom).default}});

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _Cursor = __webpack_require__(10);
	
		var _Cursor2 = _interopRequireDefault(_Cursor);
	
		var _Backspace = __webpack_require__(12);
	
		var _Backspace2 = _interopRequireDefault(_Backspace);
	
		var _Delay = __webpack_require__(13);
	
		var _Delay2 = _interopRequireDefault(_Delay);
	
		var _utils = __webpack_require__(14);
	
		var utils = _interopRequireWildcard(_utils);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var ACTION_CHARS = ['🔙', '⏰'];
	
		var Typist = function (_Component) {
		  _inherits(Typist, _Component);
	
		  function Typist(props) {
		    _classCallCheck(this, Typist);
	
		    var _this = _possibleConstructorReturn(this, (Typist.__proto__ || Object.getPrototypeOf(Typist)).call(this, props));
	
		    _this.state = {
		      textLines: [],
		      isDone: false
		    };
	
		    _this.onTypingDone = function () {
		      if (!_this.mounted) {
		        return;
		      }
		      _this.setState({ isDone: true });
		      _this.props.onTypingDone();
		    };
	
		    _this.delayGenerator = function (line, lineIdx, character, charIdx) {
		      var mean = _this.props.avgTypingDelay;
		      var std = _this.props.stdTypingDelay;
	
		      return _this.props.delayGenerator(mean, std, {
		        line: line,
		        lineIdx: lineIdx,
		        character: character,
		        charIdx: charIdx,
		        defDelayGenerator: function defDelayGenerator() {
		          var mn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mean;
		          var st = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : std;
		          return utils.gaussianRnd(mn, st);
		        }
		      });
		    };
	
		    _this.typeLine = function (line, lineIdx) {
		      if (!_this.mounted) {
		        return Promise.resolve();
		      }
	
		      var decoratedLine = line;
		      var onLineTyped = _this.props.onLineTyped;
	
	
		      if (utils.isBackspaceElement(line)) {
		        if (line.props.delay > 0) {
		          _this.introducedDelay = line.props.delay;
		        }
		        decoratedLine = String('🔙').repeat(line.props.count);
		      } else if (utils.isDelayElement(line)) {
		        _this.introducedDelay = line.props.ms;
		        decoratedLine = '⏰';
		      }
	
		      return new Promise(function (resolve, reject) {
		        _this.setState({ textLines: _this.state.textLines.concat(['']) }, function () {
		          utils.eachPromise(decoratedLine, _this.typeCharacter, decoratedLine, lineIdx).then(function () {
		            return onLineTyped(decoratedLine, lineIdx);
		          }).then(resolve).catch(reject);
		        });
		      });
		    };
	
		    _this.typeCharacter = function (character, charIdx, line, lineIdx) {
		      if (!_this.mounted) {
		        return Promise.resolve();
		      }
		      var onCharacterTyped = _this.props.onCharacterTyped;
	
	
		      return new Promise(function (resolve) {
		        var textLines = _this.state.textLines.slice();
	
		        utils.sleep(_this.introducedDelay).then(function () {
		          _this.introducedDelay = null;
	
		          var isBackspace = character === '🔙';
		          var isDelay = character === '⏰';
		          if (isDelay) {
		            resolve();
		            return;
		          }
	
		          if (isBackspace && lineIdx > 0) {
		            var prevLineIdx = lineIdx - 1;
		            var prevLine = textLines[prevLineIdx];
	
		            for (var idx = prevLineIdx; idx >= 0; idx--) {
		              if (prevLine.length > 0 && !ACTION_CHARS.includes(prevLine[0])) {
		                break;
		              }
		              prevLineIdx = idx;
		              prevLine = textLines[prevLineIdx];
		            }
	
		            textLines[prevLineIdx] = prevLine.substr(0, prevLine.length - 1);
		          } else {
		            textLines[lineIdx] += character;
		          }
	
		          _this.setState({ textLines: textLines }, function () {
		            var delay = _this.delayGenerator(line, lineIdx, character, charIdx);
		            onCharacterTyped(character, charIdx);
		            setTimeout(resolve, delay);
		          });
		        });
		      });
		    };
	
		    _this.mounted = false;
		    _this.linesToType = [];
		    _this.introducedDelay = null;
	
		    if (props.children) {
		      _this.linesToType = utils.extractTextFromElement(props.children);
		    }
		    return _this;
		  }
	
		  _createClass(Typist, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      this.mounted = true;
		      var _props = this.props,
		          children = _props.children,
		          startDelay = _props.startDelay;
	
		      if (children) {
		        if (startDelay > 0 && typeof window !== 'undefined') {
		          setTimeout(this.typeAllLines.bind(this), startDelay);
		        } else {
		          this.typeAllLines();
		        }
		      } else {
		        this.onTypingDone();
		      }
		    }
		  }, {
		    key: 'shouldComponentUpdate',
		    value: function shouldComponentUpdate(nextProps, nextState) {
		      if (nextState.textLines.length !== this.state.textLines.length) {
		        return true;
		      }
		      for (var idx = 0; idx < nextState.textLines.length; idx++) {
		        var line = this.state.textLines[idx];
		        var nextLine = nextState.textLines[idx];
		        if (line !== nextLine) {
		          return true;
		        }
		      }
		      return this.state.isDone !== nextState.isDone;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.mounted = false;
		    }
		  }, {
		    key: 'typeAllLines',
		    value: function typeAllLines() {
		      var _this2 = this;
	
		      var lines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.linesToType;
	
		      return utils.eachPromise(lines, this.typeLine).then(function () {
		        return _this2.onTypingDone();
		      });
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props2 = this.props,
		          className = _props2.className,
		          cursor = _props2.cursor;
		      var isDone = this.state.isDone;
	
		      var innerTree = utils.cloneElementWithSpecifiedText({
		        element: this.props.children,
		        textLines: this.state.textLines
		      });
	
		      return _react2.default.createElement(
		        'div',
		        { className: 'Typist ' + className },
		        innerTree,
		        _react2.default.createElement(_Cursor2.default, _extends({ isDone: isDone }, cursor))
		      );
		    }
		  }]);
	
		  return Typist;
		}(_react.Component);
	
		Typist.propTypes = {
		  children: _propTypes2.default.node,
		  className: _propTypes2.default.string,
		  avgTypingDelay: _propTypes2.default.number,
		  stdTypingDelay: _propTypes2.default.number,
		  startDelay: _propTypes2.default.number,
		  cursor: _propTypes2.default.object,
		  onCharacterTyped: _propTypes2.default.func,
		  onLineTyped: _propTypes2.default.func,
		  onTypingDone: _propTypes2.default.func,
		  delayGenerator: _propTypes2.default.func
		};
		Typist.defaultProps = {
		  className: '',
		  avgTypingDelay: 70,
		  stdTypingDelay: 25,
		  startDelay: 0,
		  cursor: {},
		  onCharacterTyped: function onCharacterTyped() {},
		  onLineTyped: function onLineTyped() {},
		  onTypingDone: function onTypingDone() {},
		  delayGenerator: utils.gaussianRnd
		};
		exports.default = Typist;
	
	
		Typist.Backspace = _Backspace2.default;
		Typist.Delay = _Delay2.default;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		if (false) {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
	
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
	
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = __webpack_require__(3)(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(9)();
		}
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(4);
		var invariant = __webpack_require__(5);
		var warning = __webpack_require__(6);
	
		var ReactPropTypesSecret = __webpack_require__(7);
		var checkPropTypes = __webpack_require__(8);
	
		module.exports = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
	
		  var ANONYMOUS = '<<anonymous>>';
	
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
	
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker
		  };
	
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
	
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
	
		  function createChainableTypeChecker(validate) {
		    if (false) {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
	
		      if (secret !== ReactPropTypesSecret) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if (false) {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
	
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
	
		    return chainedCheckType;
		  }
	
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
	
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		  }
	
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
	
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		      var checker = arrayOfTypeCheckers[i];
		      if (typeof checker !== 'function') {
		        warning(
		          false,
		          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
		          'received %s at index %s.',
		          getPostfixForTypeWarning(checker),
		          i
		        );
		        return emptyFunction.thatReturnsNull;
		      }
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		          return null;
		        }
		      }
	
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
	
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
	
		        return true;
		      default:
		        return false;
		    }
		  }
	
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
	
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
	
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
	
		    return false;
		  }
	
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
	
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    if (typeof propValue === 'undefined' || propValue === null) {
		      return '' + propValue;
		    }
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
	
		  // Returns a string that is postfixed to a warning about an invalid type.
		  // For example, "undefined" or "of type array"
		  function getPostfixForTypeWarning(value) {
		    var type = getPreciseType(value);
		    switch (type) {
		      case 'array':
		      case 'object':
		        return 'an ' + type;
		      case 'boolean':
		      case 'date':
		      case 'regexp':
		        return 'a ' + type;
		      default:
		        return type;
		    }
		  }
	
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
	
		  ReactPropTypes.checkPropTypes = checkPropTypes;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
	
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
	
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
	
		module.exports = emptyFunction;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var validateFormat = function validateFormat(format) {};
	
		if (false) {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2014-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(4);
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = emptyFunction;
	
		if (false) {
		  (function () {
		    var printWarning = function printWarning(format) {
		      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		        args[_key - 1] = arguments[_key];
		      }
	
		      var argIndex = 0;
		      var message = 'Warning: ' + format.replace(/%s/g, function () {
		        return args[argIndex++];
		      });
		      if (typeof console !== 'undefined') {
		        console.error(message);
		      }
		      try {
		        // --- Welcome to debugging React ---
		        // This error was thrown as a convenience so that you can use this stack
		        // to find the callsite that caused this warning to fire.
		        throw new Error(message);
		      } catch (x) {}
		    };
	
		    warning = function warning(condition, format) {
		      if (format === undefined) {
		        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		      }
	
		      if (format.indexOf('Failed Composite propType: ') === 0) {
		        return; // Ignore CompositeComponent proptype check.
		      }
	
		      if (!condition) {
		        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		          args[_key2 - 2] = arguments[_key2];
		        }
	
		        printWarning.apply(undefined, [format].concat(args));
		      }
		    };
		  })();
		}
	
		module.exports = warning;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
		module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		if (false) {
		  var invariant = __webpack_require__(5);
		  var warning = __webpack_require__(6);
		  var ReactPropTypesSecret = __webpack_require__(7);
		  var loggedTypeFailures = {};
		}
	
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  if (false) {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		        } catch (ex) {
		          error = ex;
		        }
		        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
	
		          var stack = getStack ? getStack() : '';
	
		          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
	
		module.exports = checkPropTypes;
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(4);
		var invariant = __webpack_require__(5);
		var ReactPropTypesSecret = __webpack_require__(7);
	
		module.exports = function() {
		  function shim(props, propName, componentName, location, propFullName, secret) {
		    if (secret === ReactPropTypesSecret) {
		      // It is still safe when called from React.
		      return;
		    }
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
	
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim
		  };
	
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		__webpack_require__(11);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Cursor = function (_Component) {
		  _inherits(Cursor, _Component);
	
		  function Cursor(props) {
		    _classCallCheck(this, Cursor);
	
		    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, props));
	
		    _this._isReRenderingCursor = false;
		    _this.state = {
		      shouldRender: _this.props.show
		    };
		    return _this;
		  }
	
		  _createClass(Cursor, [{
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(nextProps) {
		      var _this2 = this;
	
		      var shouldHide = !this.props.isDone && nextProps.isDone && this.props.hideWhenDone;
		      if (shouldHide) {
		        setTimeout(function () {
		          return _this2.setState({ shouldRender: false });
		        }, this.props.hideWhenDoneDelay);
		      }
		    }
		  }, {
		    key: 'componentDidUpdate',
		    value: function componentDidUpdate() {
		      var _props = this.props,
		          show = _props.show,
		          isDone = _props.isDone;
	
		      if (!show) {
		        return;
		      }
		      if (isDone) {
		        return;
		      }
		      if (this._isReRenderingCursor) {
		        return;
		      }
	
		      // In webkit and blink, rendering the cursor alongside the text as it
		      // animates sometimes causes the text to stop rendering when it reaches
		      // a new line break, even though the underlying DOM /does/ contain
		      // the text. This seems to happen when the space available for the text is
		      // at a specific width that makes it so the line break happens within a
		      // word.
		      // Using dev tools, when in this state, if you modify the dom or any style,
		      // it immediately renders all of the text in its correct position.
		      // Given that observation, this is a hackish solutions that re-renders the
		      // cursor every time a character is rendered, just to ensure that the text
		      // is rendered correctly.
		      // See #13 and #15 for more details
		      this._reRenderCursor();
		    }
		  }, {
		    key: '_reRenderCursor',
		    value: function _reRenderCursor() {
		      var _this3 = this;
	
		      this._isReRenderingCursor = true;
		      this.setState({ shouldRender: false }, function () {
		        _this3.setState({ shouldRender: true }, function () {
		          _this3._isReRenderingCursor = false;
		        });
		      });
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      if (this.state.shouldRender) {
		        var className = this.props.blink ? ' Cursor--blinking' : '';
		        return _react2.default.createElement(
		          'span',
		          { className: 'Cursor' + className },
		          this.props.element
		        );
		      }
		      return null;
		    }
		  }]);
	
		  return Cursor;
		}(_react.Component);
	
		Cursor.propTypes = {
		  blink: _propTypes2.default.bool,
		  show: _propTypes2.default.bool,
		  element: _propTypes2.default.node,
		  hideWhenDone: _propTypes2.default.bool,
		  hideWhenDoneDelay: _propTypes2.default.number,
		  isDone: _propTypes2.default.bool
		};
		Cursor.defaultProps = {
		  blink: true,
		  show: true,
		  element: '|',
		  hideWhenDone: false,
		  hideWhenDoneDelay: 1000,
		  isDone: false
		};
		exports.default = Cursor;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
		// removed by extract-text-webpack-plugin
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Backspace = function Backspace() {
		  return _react2.default.createElement('noscript', null);
		};
	
		Backspace.componentName = 'Backspace';
	
		Backspace.propTypes = {
		  count: _propTypes2.default.number,
		  delay: _propTypes2.default.number
		};
	
		Backspace.defaultProps = {
		  count: 1,
		  delay: 0
		};
	
		exports.default = Backspace;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Delay = function Delay() {
		  return _react2.default.createElement('noscript', null);
		};
	
		Delay.componentName = 'Delay';
	
		Delay.propTypes = {
		  ms: _propTypes2.default.number.isRequired
		};
	
		exports.default = Delay;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.sleep = undefined;
	
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
		exports.gaussianRnd = gaussianRnd;
		exports.eachPromise = eachPromise;
		exports.exclude = exclude;
		exports.isBackspaceElement = isBackspaceElement;
		exports.isDelayElement = isDelayElement;
		exports.extractTextFromElement = extractTextFromElement;
		exports.cloneElement = cloneElement;
		exports.cloneElementWithSpecifiedText = cloneElementWithSpecifiedText;
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
		var sleep = exports.sleep = function sleep(val) {
		  return new Promise(function (resolve) {
		    return val != null ? setTimeout(resolve, val) : resolve();
		  });
		};
	
		function gaussianRnd(mean, std) {
		  var times = 12;
		  var sum = 0;
		  for (var idx = 0; idx < times; idx++) {
		    sum += Math.random();
		  }
		  sum -= times / 2;
		  return Math.round(sum * std) + mean;
		}
	
		function eachPromise(arr, iterator) {
		  for (var _len = arguments.length, extraArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
		    extraArgs[_key - 2] = arguments[_key];
		  }
	
		  var promiseReducer = function promiseReducer(prev, current, idx) {
		    return prev.then(function () {
		      return iterator.apply(undefined, [current, idx].concat(extraArgs));
		    });
		  };
		  return Array.from(arr).reduce(promiseReducer, Promise.resolve());
		}
	
		function exclude(obj, keys) {
		  var res = {};
		  for (var key in obj) {
		    if (keys.indexOf(key) === -1) {
		      res[key] = obj[key];
		    }
		  }
		  return res;
		}
	
		function isBackspaceElement(element) {
		  return element && element.type && element.type.componentName === 'Backspace';
		}
	
		function isDelayElement(element) {
		  return element && element.type && element.type.componentName === 'Delay';
		}
	
		function extractTextFromElement(element) {
		  var stack = element ? [element] : [];
		  var lines = [];
	
		  while (stack.length > 0) {
		    var current = stack.pop();
		    if (_react2.default.isValidElement(current)) {
		      if (isBackspaceElement(current) || isDelayElement(current)) {
		        // If it is a `Backspace` or `Delay` element, we want to keep it in our
		        // `textLines` state. These will serve as markers when updating the
		        // state of the text
		        lines.unshift(current);
		      } else {
		        _react2.default.Children.forEach(current.props.children, function (child) {
		          stack.push(child);
		        });
		      }
		    } else if (Array.isArray(current)) {
		      var _iteratorNormalCompletion = true;
		      var _didIteratorError = false;
		      var _iteratorError = undefined;
	
		      try {
		        for (var _iterator = current[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
		          var el = _step.value;
	
		          stack.push(el);
		        }
		      } catch (err) {
		        _didIteratorError = true;
		        _iteratorError = err;
		      } finally {
		        try {
		          if (!_iteratorNormalCompletion && _iterator.return) {
		            _iterator.return();
		          }
		        } finally {
		          if (_didIteratorError) {
		            throw _iteratorError;
		          }
		        }
		      }
		    } else {
		      lines.unshift(current);
		    }
		  }
	
		  return lines;
		}
	
		function cloneElement(element, children) {
		  var tag = element.type;
		  var props = exclude(element.props, ['children']);
		  var getMilliseconds = new Date().getUTCMilliseconds();
		  var randomStamp = getMilliseconds + Math.random() + Math.random();
		  // eslint-disable-next-line
		  props.key = 'Typist-element-' + tag + '-' + randomStamp;
		  return _react2.default.createElement.apply(_react2.default, [tag, props].concat(_toConsumableArray(children)));
		}
	
		function cloneElementWithSpecifiedTextAtIndex(element, textLines, textIdx) {
		  if (textIdx >= textLines.length) {
		    return [null, textIdx];
		  }
	
		  var idx = textIdx;
		  var recurse = function recurse(el) {
		    var _cloneElementWithSpec = cloneElementWithSpecifiedTextAtIndex(el, textLines, idx),
		        _cloneElementWithSpec2 = _slicedToArray(_cloneElementWithSpec, 2),
		        child = _cloneElementWithSpec2[0],
		        advIdx = _cloneElementWithSpec2[1];
	
		    idx = advIdx;
		    return child;
		  };
	
		  var isNonTypistElement = _react2.default.isValidElement(element) && !(isBackspaceElement(element) || isDelayElement(element));
	
		  if (isNonTypistElement) {
		    var clonedChildren = _react2.default.Children.map(element.props.children, recurse) || [];
		    return [cloneElement(element, clonedChildren), idx];
		  }
	
		  if (Array.isArray(element)) {
		    var children = element.map(recurse);
		    return [children, idx];
		  }
	
		  // Anything that isn't a React element or an Array is interpreted as text
		  return [textLines[idx], idx + 1];
		}
	
		function cloneElementWithSpecifiedText(_ref) {
		  var element = _ref.element,
		      textLines = _ref.textLines;
	
		  if (!element) {
		    return undefined;
		  }
	
		  return cloneElementWithSpecifiedTextAtIndex(element, textLines, 0)[0];
		}
	
	/***/ })
	/******/ ]);

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(73);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ContainerModule = __webpack_require__(98);
	
	var _ContainerModule2 = _interopRequireDefault(_ContainerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = function Container(props) {
	  var _cx;
	
	  var children = props.children;
	
	  var classes = (0, _classnames2.default)(_ContainerModule2.default.container, (_cx = {}, _cx[_ContainerModule2.default.text] = props.text, _cx));
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes },
	    children
	  );
	};
	
	exports.default = Container;
	module.exports = exports['default'];

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Container----Container-module---container---3KHiT","text":"src-components-Container----Container-module---text---2-KQ0"};

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FooterModule = __webpack_require__(52);
	
	var _FooterModule2 = _interopRequireDefault(_FooterModule);
	
	var _SiteConfig = __webpack_require__(13);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: _FooterModule2.default.footer },
	    'An ',
	    _react2.default.createElement(
	      'a',
	      { href: 'https://github.com/LeKoArts/gatsby-starter-portfolio-emma', target: '_blank' },
	      'Emma Theme'
	    ),
	    ' ',
	    ' by ',
	    ' ',
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.lekoarts.de', target: '_blank' },
	      'LekoArts'
	    ),
	    ' I\'ve modified. ',
	    _react2.default.createElement('br', null),
	    _SiteConfig2.default.copyright
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer":"src-components-Footer----Footer-module---footer---VUGIP"};

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactReveal = __webpack_require__(35);
	
	var _HeaderModule = __webpack_require__(99);
	
	var _HeaderModule2 = _interopRequireDefault(_HeaderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: _HeaderModule2.default.header },
	    _react2.default.createElement(
	      _reactReveal.Fade,
	      { down: true, tag: 'h1' },
	      children
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-components-Header----Header-module---header---2gV_n"};

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(28);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(71);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(44);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _SiteConfig = __webpack_require__(13);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Container = __webpack_require__(70);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _reactTypist = __webpack_require__(54);
	
	var _reactTypist2 = _interopRequireDefault(_reactTypist);
	
	var _Typist = __webpack_require__(256);
	
	var _Typist2 = _interopRequireDefault(_Typist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container about-container' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'About | ' + _SiteConfig2.default.siteTitle }),
	    _react2.default.createElement(
	      _Header2.default,
	      null,
	      _react2.default.createElement(
	        _reactTypist2.default,
	        {
	          avgTypingSpeed: 30,
	          cursor: { blink: true }
	        },
	        _react2.default.createElement(
	          'span',
	          null,
	          'About '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      { text: true },
	      _react2.default.createElement(
	        'p',
	        null,
	        'I\'m a modern day technologist who graduated from UCSB (philosophy). I\'ve worked in tech for the past 9 years in various capacities (full-stack javascript developer, project manager, IT administrator, etc). I\'m passionate about problem-solving and building elegant solutions as well as collaborating on cross-functional teams and managing projects.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Additionally, I\'m an active musician who is experienced in running small DIY campaigns. Given my passions and experience, I\'m very interested in the intersection of data, media, and marketing. Through my unique experience, I\'m eager to bring value to your team as either a technical project manager, product manager or engineer.'
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-jsx-507e4803d635afb30b22.js